import { Component, OnInit, Input } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-cq7',
  templateUrl: './cq7.component.html',
  styleUrls: ['./cq7.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq7Component implements OnInit {

  @Input() data: any;
  sqft: String;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  disablebutton = false;
  showbutton = true;
  deviceWidth;
  question_sub1;
  question_sub2;
  question_sub3;
  user_bot;
  sqfts = [];
  timer;
  time = 3000;
  showTyping = false;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
   }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('space ');
          this.question_sub1 = question_sub1[0] + 'space';
          this.question_sub2 = question_sub1[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.sqfts = obj.fieldValue;
        if (!_.isEmpty(this.sqfts) && !this.commercialService.addAddress) {
          let index;
          if (this.commercialService.serialNumber === null) {
            index = 0;
          } else if (this.commercialService.serialNumber !== null) {
            index = this.commercialService.serialNumber;
          }
          if (!_.isEmpty(this.sqfts[index])) {
            this.sqft = this.sqfts[index].value;
            this.disablebutton = true;
            if (this.deviceWidth < 768) {
              if (this.commercialService.modifyAddress) {
                this.typingNext();
              } else {
                this.getSqft();
              }
            }
          }
        }
      }
    }
    $('#sqft').keypress(function (e) {
      if (e.which !== 8 && e.which !== 0 && ((e.which < 48 && e.which !== 45) || e.which > 57)) {
          return false;
      } else if ((e.currentTarget['value'].indexOf('-') > -1) && (e.which === 45)) {
        return false;
      }
    });
    $('#sqft_mob').keypress(function (e) {
      if (e.which !== 8 && e.which !== 0 && ((e.which < 48 && e.which !== 45) || e.which > 57)) {
          return false;
      }  else if ((e.currentTarget['value'].indexOf('-') > -1) && (e.which === 45)) {
        return false;
      }
    });

    if(_.isEmpty(this.sqft))
    {
      this.showbutton = false;
    }
  }

  typingNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
      this.showTyping = true;
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  enableButton() {
    if (this.sqft === null || this.sqft === undefined) {
      this.disablebutton = false;
    } else {
      this.disablebutton = true;
    }
  }

  getSqft() {
    if (this.sqft === null || this.sqft === undefined) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.disablebutton = true;
      let index;
      if (this.commercialService.serialNumber !== null) {
        index = this.commercialService.serialNumber;
      } else {
        index = this.sqfts.length;
      }
      this.sqfts[index] = { 'serialNo': index + 1, 'value': this.sqft}
      const Obj = {
        'com_question_id': this.data,
        'fieldName': 'sqft',
        'fieldValue': this.sqfts
      };
      this.commercialService.updateResponses(Obj);
      this.next();
      if (this.deviceWidth < 768) {
        document.getElementById('sqft_mob').blur();
      }
    }
  }

  next() {
    this.commercialService.messageService({ 'currentId': this.data });
  }

}